import { Box } from '@opendoor/bricks-next';

interface SpinningGradientProps {
  children: React.ReactNode;
}

const SpinningGradient: React.FC<SpinningGradientProps> = ({ children }) => {
  return (
    <Box
      position="relative"
      backgroundColor="$backgroundInversePrimary"
      marginTop={200}
      $smallerThanMD={{ marginTop: 100 }}
    >
      <Box position="relative" zIndex={2}>
        {children}
      </Box>
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        style={{ overflow: 'visible' }}
      >
        <Box className="blur">
          <Box className="gradient-mask">
            <Box className="spinning-gradient" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SpinningGradient;
